export const SL_WEB_AUS_LAUNCH_MODAL = 'sl_web_aus_launch_modal';
